<template>
  <div>
    <transition name="slide">
      <div v-if="errMsg" class="footer-container error-container">
        <div class="err-wrapper">
          {{ errMsg }}
        </div>
        <div class="err-wrapper">
          <div class="alarm-btn error-btn" @click="redirect(errHref)">
            {{ errBtn }}
          </div>
        </div> </div
      ><div
        v-else-if="alarmingDevices.length"
        class="footer-container alarm-container"
      >
        <div class="alarm-icon" />
        <div class="err-wrapper">
          <div class="select-wrapper">
            <select ref="currentAlarm">
              <option v-for="dev in alarmingDevices" :value="dev" :key="dev">
                {{ getDeviceName(dev) }}
              </option>
            </select> </div
          ><div
            :class="[
              'alarm-btn btn-1',
              { 'clear-events': getExternalDevice() || isExt },
            ]"
            @click="viewDevice"
          >
            {{ $t('DIALOG.str98') }}
          </div> </div
        ><div class="err-wrapper">
          <div class="alarm-btn btn-2" @click="clearAlarm">
            {{ $t('DIALOG.str99') }} </div
          ><div class="alarm-btn btn-3" @click="clearAllAlarms">
            {{ $t('DIALOG.str100') }} ({{ alarmingDevices.length }})
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { FooterMsg } from '@/js/plugin';
export default {
  name: 'Footer',
  data() {
    return {
      errMsg: null,
      errBtn: null,
      errLink: null,
      isReload: null,
      priority: 0,
      isExt: false,
    };
  },
  computed: {
    errHref() {
      return this.isReload ? this.$route.path : this.errLink;
    },
    alarmingDevices() {
      return this.$store.getters['mqtt/alarmState']()
        .map((el) => el.mac_addr)
        .filter((dev, index, arr) => arr.indexOf(dev) === index);
    },
    settingData() {
      return this.$store.getters['ports/settingData'];
    },
  },
  methods: {
    renderMessage({ errMsg, errBtn, errLink, errReload, priority }) {
      if (this.priority < priority) {
        this.priority = priority;
        this.errMsg = errMsg;
        this.errBtn = errBtn;
        this.errLink = errLink;
        this.isReload = errReload;
      }
    },
    viewDevice() {
      if (this.settingData) {
        const params = {
          title: this.$t('DIALOG.str95'),
          content: [this.$t('DIALOG.str82')],
          btnConfirm: this.$t('DIALOG.str13'),
          btnCancel: this.$t('DIALOG.str11'),
          onConfirm: () => {
            this.$store
              .dispatch('ports/clearSettingData')
              .then(() => this.openExpandedView());
          },
        };
        this.$modal.show(params);
      } else {
        this.openExpandedView();
      }
    },
    clearAlarm() {
      const targetDev = this.$refs.currentAlarm.value;
      if (!targetDev) return;
      this.$store.dispatch('mqtt/deactivateAlarmState', {
        mac_addr: targetDev,
      });
    },
    clearAllAlarms() {
      this.$store.dispatch('mqtt/deactivateAlarmState');
    },
    openExpandedView() {
      const targetDev = this.$refs.currentAlarm.value;
      if (!targetDev) return;
      const portName = this.$store.getters['mqtt/alarmState']({
        mac_addr: targetDev,
      })[0].port_id;
      const dest = '/dashboard/' + targetDev + (portName ? '/' + portName : '');
      if (this.$route.path !== dest) this.$router.push(dest);
    },
    getDeviceName(deviceMAC) {
      const sharedDevice = this.getExternalDevice(deviceMAC);
      if (sharedDevice) return '[EXT] ' + sharedDevice.mac_addr;
      return this.$store.getters['ports/portsData'](deviceMAC).dev_nickname;
    },
    getExternalDevice(deviceMAC) {
      if (deviceMAC) {
        return this.$store.getters['ports/sharedPortList'].find(
          (dev) => dev.mac_addr === deviceMAC
        );
      }
      this.$nextTick().then(() => {
        this.isExt = this.$store.getters['ports/sharedPortList'].find(
          (dev) => dev.mac_addr === this.$refs.currentAlarm.value
        );
      });
    },
    redirect(href) {
      location.replace(href);
    },
  },
  mounted() {
    FooterMsg.EventBus.$on('set', this.renderMessage);
  },
  beforeDestroy() {
    FooterMsg.EventBus.$off();
  },
};
</script>
<style scoped>
.footer-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  min-width: 280px;
  min-height: 50px;
  padding: 5px 0;
  z-index: 10000;
  color: #fff;
  text-align: center;
}

.err-wrapper {
  margin: 5px auto;
}

.err-wrapper + .err-wrapper {
  margin-top: 7.5px;
}

.error-container {
  background-color: rgba(192, 57, 43, 0.95);
}

.alarm-container {
  background-color: rgba(133, 133, 133, 0.95);
}

select {
  border-color: #fff;
  color: #fff;
  background-color: #858585;
  max-width: 12em;
  min-width: 12em;
}

.select-wrapper {
  display: inline-block;
  vertical-align: middle;
  margin-right: 0.25em;
}

.select-wrapper:after {
  border-top-color: #fff;
}

.alarm-btn {
  display: inline-block;
  vertical-align: middle;
  border-radius: 0.25em;
  border: 1px solid #fff;
  box-sizing: border-box;
  cursor: pointer;
  padding: 0.1em 0;
  transition: 0.2s;
}

.alarm-btn + .alarm-btn {
  margin-left: 0.25em;
}

.alarm-btn:hover {
  color: #858585;
  border-color: #858585;
  background-color: #fff;
}

.error-btn {
  padding: 0.1em 10px;
}

.error-btn:hover {
  color: #a43434;
  border-color: #a43434;
  background-color: #fff;
}

.btn-1 {
  width: 5em;
}

.btn-2 {
  width: 4.5em;
}

.btn-3 {
  width: 12.5em;
}

.alarm-icon {
  position: absolute;
  top: calc(50% - 0.75em);
  left: calc(50% - 11em);
  width: 1.5em;
  height: 1.5em;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(~@/assets/img/btn_alarm_view_white.png);
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 1s;
}
.slide-enter,
.slide-leave-to {
  transform: translateY(100%);
}
</style>
